// project import
import dashboard from './dashboard';
import batches from './batches';
import crops from './crops';

// ==============================|| MENU ITEMS ||============================== //

// Filters the "Farm" nav group by the organization's farmFocus (LIVESTOCK/CROPS/BOTH,
// see docs/product/08-farm-manager-gaps.md section G). A missing farmFocus (unset, or an
// organization that predates this field) defaults to Livestock Batches, same as
// every organization saw before farmFocus existed.
export function buildMenuItems(farmFocus) {
  const items = [dashboard];
  if (farmFocus === 'CROPS') {
    items.push(crops);
  } else if (farmFocus === 'BOTH') {
    items.push(batches, crops);
  } else {
    items.push(batches);
  }
  return { items };
}

const menuItems = buildMenuItems(null);

export default menuItems;
